import { render } from "./editorProntuario.vue?vue&type=template&id=1cab6bab&scoped=true"
import script from "./editorProntuario.vue?vue&type=script&lang=js"
export * from "./editorProntuario.vue?vue&type=script&lang=js"

import "./editorProntuario.vue?vue&type=style&index=0&id=1cab6bab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cab6bab"]])

export default __exports__